// LiveStreamPusherHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

import { PRESET_SD } from '../resource/liveStreamConstants.js';

export class LiveStreamPusherHandler extends React.PureComponent {
  componentDidMount() {
    const {
      streamId,
      pusherPreset,
      fundingId,
      meId,
      subscribeStreamChannel,
      subscribeStreamViewerChannel,
      subscribePresenceGoalChannel,
      shouldSubscribeStreamChannel,
    } = this.props;
    if (shouldSubscribeStreamChannel) {
      subscribeStreamChannel({
        streamId,
      });
    }
    subscribeStreamViewerChannel({
      streamId,
      preset: pusherPreset,
    });
    subscribePresenceGoalChannel({
      goalId: fundingId,
      userId: meId,
    });
  }
  componentDidUpdate(prevProps) {
    const {
      streamId,
      pusherPreset,
      meId,
      fundingId,
      subscribeStreamViewerChannel,
      unsubscribeStreamViewerChannel,
      subscribePresenceGoalChannel,
      unsubscribePresenceGoalChannel,
    } = this.props;
    if (prevProps.pusherPreset !== pusherPreset) {
      unsubscribeStreamViewerChannel({
        streamId,
        preset: prevProps.pusherPreset,
      });
      subscribeStreamViewerChannel({
        streamId,
        preset: pusherPreset,
      });
    }
    if (meId !== prevProps.meId) {
      unsubscribePresenceGoalChannel({
        goalId: fundingId,
        userId: prevProps.meId,
      });
      subscribeStreamViewerChannel({
        streamId,
        preset: pusherPreset,
      });
      subscribePresenceGoalChannel({
        userId: meId,
        goalId: fundingId,
      });
    }
    if (fundingId !== prevProps.fundingId) {
      unsubscribePresenceGoalChannel({
        userId: meId,
        goalId: prevProps.fundingId,
      });
      subscribePresenceGoalChannel({
        userId: meId,
        goalId: fundingId,
      });
    }
  }
  componentWillUnmount() {
    const {
      streamId,
      meId,
      fundingId,
      pusherPreset,
      unsubscribeStreamViewerChannel,
      unsubscribeStreamChannel,
      unsubscribePresenceGoalChannel,
    } = this.props;
    unsubscribeStreamChannel({
      streamId,
    });
    unsubscribeStreamViewerChannel({
      streamId,
      preset: pusherPreset,
    });
    unsubscribePresenceGoalChannel({
      userId: meId,
      goalId: fundingId,
    });
  }
  render() {
    return null;
  }
}

LiveStreamPusherHandler.propTypes = {
  streamId: PropTypes.string,
  pusherPreset: PropTypes.string,
  meId: PropTypes.string,
  fundingId: PropTypes.string,
  subscribeStreamChannel: PropTypes.func,
  subscribeStreamViewerChannel: PropTypes.func,
  unsubscribeStreamChannel: PropTypes.func,
  unsubscribeStreamViewerChannel: PropTypes.func,
  subscribePresenceGoalChannel: PropTypes.func,
  unsubscribePresenceGoalChannel: PropTypes.func,
  shouldSubscribeStreamChannel: PropTypes.bool,
};

LiveStreamPusherHandler.defaultProps = {
  streamId: null,
  pusherPreset: PRESET_SD,
  meId: null,
  fundingId: null,
  subscribeStreamChannel: () => null,
  subscribeStreamViewerChannel: () => null,
  unsubscribeStreamChannel: () => null,
  unsubscribeStreamViewerChannel: () => null,
  subscribePresenceGoalChannel: () => null,
  unsubscribePresenceGoalChannel: () => null,
  shouldSubscribeStreamChannel: true,
};

export default LiveStreamPusherHandler;
